import { Button, Card, Input, Notification, Tabs, Typography } from "@arco-design/web-react";
import md5 from "js-md5";
import ArcCalculation from "./components/ArcCalculation";
import LinearSpeedCalculation from "./components/LinearSpeedCalculation";
import TiltAxisCalculation from "./components/TiltAxisCalculation";
import TaperCalculation from "./components/TaperCalculation";
import img from "./asset/img.png";
import { useEffect, useState } from "react";
import { IconArrowRight } from "@arco-design/web-react/icon";
import LongitudinalCalculation from "./components/LongitudinalCalculation";
import MDTCalculation from "./components/MDTCalculation";
import CharacterConverter from "./components/CharacterConverter";
import DresserProgramGenerator from "./components/DresserProgramGenerator";

const TabPane = Tabs.TabPane;

const App = () => {
  const [show, setShow] = useState(false);
  const [password, setPassword] = useState("");
  const [tab, setTab] = useState("1");
  useEffect(() => {
    const token = localStorage.getItem("password");
    if (token && token === md5(md5(process.env.REACT_APP_PASSWORD) + process.env.REACT_APP_PASSWORD)) {
      setShow(true);
    }
    setTab(localStorage.getItem("tab") ?? "1");
  }, []);
  const onSubmit = () => {
    const passwordWithMd5 = md5(md5(password) + password);
    if (passwordWithMd5 === md5(md5(process.env.REACT_APP_PASSWORD) + process.env.REACT_APP_PASSWORD)) {
      localStorage.setItem("password", passwordWithMd5);
      setShow(true);
    } else {
      Notification.error({
        closable: false,
        title: "Notification",
        content: "密码错误！",
      });
    }
  };

  const onChangeTab = (value) => {
    localStorage.setItem("tab", value);
  };
  // window.addEventListener("beforeunload", () => {
  //     localStorage.removeItem("password");
  // })
  return (
    <div className="app">
      <div className="title-wrapper">
        <span>数控外圆磨床编程助手</span>
      </div>
      <Card className="box-wrapper">
        {show ? (
          <Tabs defaultActiveTab={tab} scrollPosition="auto" onChange={onChangeTab}>
            <TabPane key="1" title="圆弧计算">
              <ArcCalculation />
            </TabPane>
            <TabPane key="2" title="线速度计算">
              <LinearSpeedCalculation />
            </TabPane>
            <TabPane key="3" title="倾斜轴相关计算">
              <TiltAxisCalculation />
            </TabPane>
            <TabPane key="4" title="中差 / 数据分析">
              <MDTCalculation />
            </TabPane>
            <TabPane key="5" title="锥度计算">
              <TaperCalculation />
            </TabPane>
            <TabPane key="6" title="纵磨计算">
              <LongitudinalCalculation />
            </TabPane>
            <TabPane key="7" title="中文转码">
              <CharacterConverter />
            </TabPane>
            <TabPane key="8" title="修砂轮程序生成">
              <DresserProgramGenerator />
            </TabPane>
            <TabPane key="9" title="其它">
              <Typography.Title>敬请期待！</Typography.Title>
            </TabPane>
          </Tabs>
        ) : (
          <div className="login-wrapper">
            <img src={img} alt="" style={{ width: "85%", maxWidth: 400 }} />
            <div className="login-desc">
              <h2>密码验证</h2>
              <p>这个路由（页面）有密码保护。如果你知道密码，请在下面输入。</p>
              {document.body.clientWidth >= 780 ? (
                <div style={{ display: "flex" }}>
                  <Input.Password
                    style={{ maxWidth: 350, height: 40 }}
                    placeholder="********"
                    size="large"
                    onChange={(value) => setPassword(value)}
                    onPressEnter={onSubmit}
                  />
                  <Button
                    type="primary"
                    icon={<IconArrowRight />}
                    style={{ marginLeft: 10, width: 50, height: 40, marginBottom: 30 }}
                    onClick={onSubmit}
                  />
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Input.Password
                    style={{ maxWidth: 350, height: 40 }}
                    placeholder="********"
                    size="large"
                    onChange={(value) => setPassword(value)}
                    onPressEnter={onSubmit}
                  />
                  <Button
                    type="primary"
                    icon={<IconArrowRight />}
                    long
                    style={{ height: 40, marginTop: 10, marginBottom: 20 }}
                    onClick={onSubmit}
                  >
                    验证
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};

export default App;
